import Vue from 'vue';

const bus = new Vue({});
export type Unsubscribe = () => void;

class Service {
	toggleNav() {
		bus.$emit("toggleNav");
	}

	onToggleNav(fn): Unsubscribe {
		bus.$on("toggleNav", fn);
		return () => bus.$off("toggleNav", fn);
	}
}

export default new Service();